// extracted by mini-css-extract-plugin
export default {"specialOffer":"SpecialOffer_specialOffer__ECDXW"};